import { useRef, useState, useEffect } from "react";

export function ExpandableText({ text, className = "", style = {}, testid }) {
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // measure only in collapsed state
    if (!expanded) setOverflowing(el.scrollHeight > el.clientHeight + 2);
  }, [text, expanded]);

  return (
    <div>
      <p
        ref={ref}
        data-testid={testid}
        className={`${expanded ? "expanded-text" : "long-text"} ${className}`}
        style={expanded ? { ...style, whiteSpace: "pre-wrap", overflowWrap: "anywhere" } : style}
      >
        {text}
      </p>
      {(overflowing || expanded) && (
        <button
          onClick={() => setExpanded((v) => !v)}
          data-testid={testid ? `${testid}-toggle` : undefined}
          className="text-xs tracking-widest uppercase mt-2 opacity-60 hover:opacity-100 transition-opacity"
          style={{ color: "var(--accent)" }}
        >
          {expanded ? "collapse ↑" : "show full text ↓"}
        </button>
      )}
    </div>
  );
}
